var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomColor = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F66",
  d: "M24.588 5.102A13.97 13.97 0 0 1 28 13.32h-8.876a5.2 5.2 0 0 0-.81-1.96l6.274-6.271zM8.863 15.28H0a13.97 13.97 0 0 0 3.412 8.218l6.274-6.271a5.3 5.3 0 0 1-.81-1.96zm0-1.96c.13-.719.418-1.372.81-1.96L3.412 5.102A13.97 13.97 0 0 0 0 13.32h8.876zm10.261 1.96a5.2 5.2 0 0 1-.81 1.96l6.274 6.271A13.97 13.97 0 0 0 28 15.293h-8.876zM14.98.307v8.871c.72.13 1.373.418 1.961.81l6.275-6.271a14 14 0 0 0-8.223-3.41zm1.961 18.318a5.3 5.3 0 0 1-1.96.81v8.872a14 14 0 0 0 8.222-3.41l-6.275-6.272zm-5.87-8.637a5.3 5.3 0 0 1 1.962-.81V.307a14 14 0 0 0-8.223 3.41l6.275 6.271zm1.962 9.447a5.2 5.2 0 0 1-1.961-.81l-6.275 6.271a14 14 0 0 0 8.223 3.41v-8.871z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF9466",
  d: "M8.863 15.28H0A13.97 13.97 0 0 0 3.412 23.5l6.274-6.272a5.3 5.3 0 0 1-.81-1.96z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFE55C",
  d: "M13.033 19.435a5.2 5.2 0 0 1-1.96-.81l-6.275 6.271a14 14 0 0 0 8.222 3.41v-8.871z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#ADE65C",
  d: "M16.94 18.625a5.3 5.3 0 0 1-1.96.81v8.872a14 14 0 0 0 8.222-3.41l-6.275-6.272z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#7ACC52",
  d: "M19.124 15.28a5.2 5.2 0 0 1-.81 1.96l6.274 6.272A13.97 13.97 0 0 0 28 15.293h-8.876z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#4D88FF",
  d: "M24.588 5.102A13.97 13.97 0 0 1 28 13.32h-8.876a5.2 5.2 0 0 0-.81-1.96l6.274-6.271z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#65B3FF",
  d: "M14.98.307v8.871c.72.13 1.373.418 1.961.81l6.275-6.271a14 14 0 0 0-8.223-3.41zm-3.908 9.681a5.3 5.3 0 0 1 1.96-.81V.307a14 14 0 0 0-8.221 3.41l6.274 6.271z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#E64560",
  d: "M11.072 9.988a5.3 5.3 0 0 1 1.96-.81V.307a14 14 0 0 0-8.221 3.41l3.137 3.136 3.137 3.135z"
})));
export default SvgCustomColor;